import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { getCurrentLanguage } from 'tradera-lang/boot-languages';

export const configureDayjs = () => {
    dayjs.locale(getCurrentLanguage());
    dayjs.extend(isBetween);
    dayjs.extend(isSameOrAfter);
};
